import {
  LifecycleSurveySettings,
  PulseTemplateLifecycleSurveysApi,
} from 'api/PulseTemplateLifecycleSurveysApi';
import { DistributionMode, LifecycleSurveysModel } from 'api/dto/LifecycleSurveys.dto';
import { ProjectModel } from 'api/dto/Project.dto';

export class PulseTemplateLifecycleSurveysRepository {
  constructor(private api: PulseTemplateLifecycleSurveysApi) {}

  get(pulseTemplateId: ProjectModel['id']): Promise<LifecycleSurveysModel> {
    return this.api.get(pulseTemplateId);
  }

  updateSettings(
    pulseTemplateId: ProjectModel['id'],
    projectId: number,
    settings: LifecycleSurveySettings,
  ): Promise<void> {
    return this.api.updateSettings(pulseTemplateId, projectId, settings);
  }

  updateDistributionMode(
    pulseTemplateId: ProjectModel['id'],
    distributionMode: DistributionMode,
  ): Promise<void> {
    return this.api.updateDistributionMode(pulseTemplateId, distributionMode);
  }
}
